import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'

import { SupplierList } from '../../features/selfservice/suppliers/data'
import i18n from '../../utils/i18n'

export const ProjectFilterTemplate = (
  options: any,
  suppliers?: SupplierList,
) => {
  if (!options || !suppliers) return null

  return (
    <Dropdown
      value={options.value}
      options={suppliers}
      optionLabel="Name"
      optionValue="Name"
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      className="p-column-filter"
      placeholder={i18n.t(
        'roleAssignments.table.columns.project.filterPlaceholder',
      )}
    />
  )
}
